import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-bheem-awardees',
  templateUrl: './bheem-awardees.component.html',
  styleUrls: ['./bheem-awardees.component.scss']
})
export class BheemAwardeesComponent implements OnInit {

  awardees = [
    {
      name: 'Gurmail',
      sport: 'Handball',
      image: '/assets/bheem awardes/Gurmail,  BHIM Award ,International player  Hand ball.jpeg'
    },
    {
      name: 'Harpreet',
      sport: 'Skating',
      image: '/assets/bheem awardes/Harpreet , Bhim AWARD ,International  Player ,Skating.jpeg'
    },
    {
      name: 'Milanpreet Kaur',
      sport: 'Skating',
      image: '/assets/bheem awardes/Milanpreet kaur, BhimAward, International player, Skating.jpeg'
    },
    {
      name: 'Parveen',
      sport: 'Skating',
      image: '/assets/bheem awardes/Parveen , Bhim Award ,International  Player ,Skating.jpeg'
    },
    {
      name: 'Yashdeep',
      sport: 'Skating',
      image: '/assets/bheem awardes/yashdeep, Bhim award  ,International player, Skating.jpeg'
    }
  ];

  constructor() { }

  ngOnInit() {
  }

}
